export enum SectionId {
  JuryPanel = 'jury-panel',
}
